<template>
    <div>
        <div v-if="images && images.length > 0">
            <img v-for="(img, index) in images" :key="'img' + index" class="recording-img" :src="img.thumbnailImageUrl" @click="enlargeImg(img.oriImageUrl)">
        </div>
        <span v-else>-</span>

        <el-dialog
            title="Image"
            :visible.sync="dialogVisible"
            width="700px"
        >
            <div class="img-container">
                <img class="img-src" :src="imgSrc">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="downloadImg()">Download</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
        }
    },
    data() {
        return {
            dialogVisible: false,
            imgSrc: null
        };
    },
    methods: {
        enlargeImg(url) {
            this.dialogVisible = true;
            this.imgSrc = url;
        },
        downloadImg() {
            this.dialogVisible = false;
            this.$_downloadMedia(this.imgSrc);
            
        }
    },
};
</script>

<style lang="scss" scoped>
.recording-img {
    width: 60px;
    height: 60px;
    object-fit: contain;
    display: inline-block;
    margin: var(--space-4);
    border: 1px solid var(--border-line);
    border-radius: 4px;
    cursor: pointer;
}
.img-container{
    text-align: center;
}
.img-src{
    width: 400px;
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/ImageHolder.vue